import React, {useEffect, useState} from 'react';
import { Snackbar, Button, Box, Typography, SnackbarContent } from '@mui/material';
import {Trans} from "react-i18next";
import {Link} from "react-router";
import {getCookie, setCookie} from "../utils/cookieHandler";

const CookieConsentBanner = () => {
    const [open, setOpen] = useState(getCookie('cookieConsent') !== 'true');

    useEffect(() => {
        if (getCookie('cookieConsent') === 'true') {
            setCookie('cookieConsent', 'true', 30);
        }
    }, []);

    const handleAccept = () => {
        setOpen(false);
        setCookie('cookieConsent', 'true', 30);
    };

    return (
        <Snackbar
            open={open}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={null} // Makes the snackbar persistent
        >
            <SnackbarContent
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: 'info.main',
                    color: 'white',
                    borderRadius: 0,
                    width: '100%',
                }}
                message={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="body2">
                            <Trans i18nKey={'legal.cookieConsent'}/>

                        </Typography>
                    </Box>
                }
                action={<>
                    <Link style={{color: 'inherit', paddingRight: 15}} to='/privacy-policy'><Trans i18nKey={`footer.links.privacy`}/></Link>
                    <Button onClick={handleAccept} color="inherit" size="small">
                        Accept
                    </Button>
                </>
                }
            />
        </Snackbar>
    );
};

export default CookieConsentBanner;
